import request from './request'

// 1. 企业账号登录
export const businessAccountLogin = (data) =>
  request({ url: '/api/login/business/account', method: 'post', data })

// 2. 查询企业信息（GET）
export const getBusinessInfo = (params) =>
  request({ url: '/api/login', method: 'get', params })

// 3. 企业退出登录
export const businessLogout = (data) =>
  request({ url: '/api/login/business/logout', method: 'post', data })

// 4. 企业手机登录
export const businessMobileLogin = (data) =>
  request({ url: '/api/login/business/mobileLogin', method: 'post', data })

// 5. 企业注册账号
export const businessRegister = (data) =>
  request({ url: '/api/login/business/register', method: 'post', data })

// 6. 用户确认公司信息
export const confirmCompanyInfo = (data) =>
  request({ url: '/api/login/business/verify/confirm', method: 'post', data })

// 7. 人脸认证绑定公司信息
export const bindCompanyByFace = (data) =>
  request({ url: '/api/login/business/verify/relation', method: 'post', data })

// 8. 企业认证输入（提交企业信息）
export const submitCompanyInfo = (data) =>
  request({ url: '/api/login/business/verify/submit', method: 'post', data })

// 8. 微信登录
export const getScanCode = (url) => request({
  url: '/api/login/getScanCode',
  method: 'get',
  params: { url }
})

// 9. 微信登录
export const wechatCallback = (code, state) => request({
  url: '/api/login/wechat/callback',
  method: 'get',
  params: { code, state }
})

